// extracted by mini-css-extract-plugin
export var lg = "_fz-4";
export var md = "_fz-3";
export var reactTimePickerInputGroupAmPm = "_fz-6";
export var redoTimePicker = "_fz-0";
export var sm = "_fz-2";
export var xl = "_fz-5";
export var xs = "_fz-1";